import { client } from "../client";
import { Address } from "../types/address.types";

export const fetchAddress = async (id: number | string | undefined | null) => {
	if (id == undefined) {
		return null;
	}
	const response = await client.get<Address>(`address/${id}`);
	return response.data;
};
